module.exports = __webpack_public_path__ + "img/27-promoting-socially.d86bcb59.jpg";